import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleUserActive } from '../../slices'
import { withStyles } from '@mui/styles'
import { Switch } from '@mui/material'

// import { toggleUserActive } from '../../slices'

const switchStyles = (theme) => ({
  root: {
    marginRight: 10,
  },
  switchBase: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  track: {
    backgroundColor: theme.palette.grey[500],
  },
  checked: {},
})

export const TableActions = withStyles(switchStyles)(({ classes, row, ...props }) => {
  const dispatch = useDispatch()
  const users = useSelector((state) => state.marketerUsers.data)
  const global = useSelector((state) => state.global)
  const switchDisabled = '' + row.original.id === global.user_id
  const userState = row.original['activo']

  const handleToggleState = (e) => {
    e.stopPropagation()
    dispatch(toggleUserActive(row, users))
  }

  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        track: classes.track,
        checked: classes.checked,
      }}
      checked={userState}
      onChange={handleToggleState}
     disabled={switchDisabled}
    />
  )
})
